import { data } from '../../svg/LocationAway/data';
import { makeIcon } from '../makeIcon';

export const LocationAway = makeIcon(data, 'location_away', 'LocationAway');

export default LocationAway;
